var render, staticRenderFns
import script from "./PathMixin.vue?vue&type=script&lang=js"
export * from "./PathMixin.vue?vue&type=script&lang=js"
import style0 from "./PathMixin.vue?vue&type=style&index=0&id=b23d9a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports